import { useEffect } from "react";

/**
 * Custom hook to prevent body scrolling when modal/overlay is open
 * @param {boolean} isOpen - Whether the modal/overlay is open
 */
export const useScrollLock = (isOpen) => {
  useEffect(() => {
    if (isOpen) {
      // Store original body style
      const originalStyle = window.getComputedStyle(document.body);
      const originalOverflow = originalStyle.overflow;
      const originalPaddingRight = originalStyle.paddingRight;

      // Calculate scrollbar width
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      // Apply styles to prevent scrolling
      document.body.style.overflow = "hidden";

      // Compensate for scrollbar width to prevent layout shift
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${
          parseInt(originalPaddingRight, 10) + scrollbarWidth
        }px`;
      }

      // Cleanup function
      return () => {
        document.body.style.overflow = originalOverflow;
        document.body.style.paddingRight = originalPaddingRight;
      };
    }
  }, [isOpen]);
};

export default useScrollLock;
